// extracted by mini-css-extract-plugin
module.exports = {"eventWrapper":"SendEventWrapper_eventWrapper__rUKa3"};